export default [
  {
    path: '/motoPlay-question',
    component: () => import('@/views/motoPlay/question/Index.vue'),
    name: 'motoPlay.question',
    meta: {
      title: 'MotoPlay常见问题',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/motoPlay-iframe',
    component: () => import('@/views/motoPlay/question/IFrame.vue'),
    name: 'motoPlay-iframe',
    meta: {
      title: '',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
  {
    path: '/motoPlay-guide',
    component: () => import('@/views/motoPlay/question/guide.vue'),
    name: 'motoPlay-guide',
    meta: {
      title: '导航防断连设置',
      backgroundClass: 'white',
    },
    hidden: true,
  },
];
